import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .introOuter {
    background: linear-gradient(145deg, #012b, #0126, #012b);
    padding: 0.6rem;
    max-width: min(740px, 100vw - 1rem);
    border-radius: 1rem;
    box-shadow:
      rgba(255, 255, 255, 0.25) 0px 1px 1px 0px inset,
      rgba(50, 50, 93, 0.6) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.7) 0px 30px 60px -30px,
      rgba(103, 178, 111, 0.6) -10px 10px 60px -10px;

    @media (min-width: 59em) {
      margin: 3rem auto 0 !important;
    }
  }
  .introInner {
    display: flex;
    align-items: center;
    gap: 1rem;
    background: repeating-conic-gradient(#0004 0 0.0001%, #0000 0 0.0002%), #0128;
    background: #0128;
    color: #fff;
    padding: 1.5rem;
    border-radius: 0.6rem;
    box-shadow:
      rgba(255, 255, 255, 0.6) 0px 1px 1px 0px inset,
      rgba(50, 50, 93, 0.7) 0px 5px 10px;
    font-size: 1.1rem;
  }

  .text {
    flex: 1 1 auto;
    line-height: 1.6;

    strong {
      font-weight: 600;
      border-radius: 0.2rem;
      padding: 0.1rem 0.4rem;
      float: left;
      background: #fff4;
      margin-right: 0.5rem;
    }

    button {
      display: inline;
      cursor: pointer;
      border: none;
      background: none;
      font-size: inherit;
      text-decoration: underline;
      color: dodgerblue;

      &:hover {
        text-decoration: none;
        color: #fffb;
      }
    }
  }
`;

function CSSTip() {
  const applymultiple = () => {
    const el = document.querySelector('#selector');
    if (el) {
      el.value = 'p, .class, #id';
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };

  return (
    <div className={styles.introOuter}>
      <div className={styles.introInner}>
        <span className={styles.text}>
          <strong>Tip</strong> Compare multiple selectors by using a comma:{' '}
          <button onClick={applymultiple}>p, .class, #id</button>. See the specificity of each and sort to see which one
          wins.
        </span>
      </div>
    </div>
  );
}

export default CSSTip;
